import { PositionType, SizeType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { SmokeAnimation } from '../../animations/SmokeAnimation';

// types
//-----------------------------------------------------------------------------
export type SmokeEffectOptions = {
  position: PositionType;
  size?: SizeType;
  tint?: number;
};

/*
    smoke effect
*/
export class SmokeEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _position: PositionType;
  private readonly _size: SizeType;
  private readonly _tint: number;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: SmokeEffectOptions) {
    this._scene = scene;
    this._position = options.position;
    this._size = options.size ?? {};
    this._tint = options.tint ?? 0xffffff;
  }

  public static assets(): string[] {
    return [];
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    // wait a frame since we async the animation
    await waitAFrame();

    // animate
    this._animate();
  }

  // private: animation
  //-------------------------------------------------------------------------
  private async _animate() {
    // create  animation
    const animation = new SmokeAnimation({
      size: this._size,
      tint: this._tint,
    });

    // spawn animation as overlay
    const entity = spawnOverlayEntity(
      this._scene,
      this._position,
      this._size,
      () => animation,
    );

    // run animations
    await animation.start();

    // despawn entity
    despawnOverlayEntity(this._scene, entity);
  }
}
